import TemplateView from "./../../TemplateView";
import {AuditActionTypes, AuditEntityTypes} from "./constants";
import $ from "jquery";
import messageResource from "../../messageResource";
import UserTime from "../../user_time";
import {DateFormat} from "../../date_format";
import {WorkflowStatusType} from '../../workflowStatus/constants';
import {Feature, isEnabled} from '../../features/index';

class ChangedValuesRow extends TemplateView
{
    templateHtml()
    {
        return "<div class='changedValueRow'><span class='oldValue'/><span class='separator'>&#10230;</span><span class='newValue'/></div>";
    }


    constructor(oldValueText, newValueText)
    {
        super();
        this.oldValueText = oldValueText;
        this.newValueText = newValueText;
    }

    afterRender()
    {
        this.find('.oldValue').text(this.formatValue(this.oldValueText));
        this.find('.newValue').text(this.formatValue(this.newValueText));
    }

    formatValue(name)
    {
        if (name.length > 50)
            return name.substring(0, 50) + "...";
        return name;
    }
}


class UpdateAuditRecord extends TemplateView
{
    templateHtml()
    {
        return "<div class='updateAuditRecord'><div class='auditRecordRow'>" +
        "  <div class='timestamp'/>" +
        "  <div class='changeInfo'>" +
        "      <div class='info'><div class='subjectName ellipsis'><%-subjectName%></div><span class='changeLabel'/></div>" +
        "      <div class='values'/>" +
        "  </div>" +
        "</div></div>";
    }

    constructor( audit, dateFormat)
    {
        super();
        this.timestamp = audit.timestamp;
        this.subject = audit.subject;
        this.data = audit.data;
        this.type = audit.type;
        this.dateFormat = dateFormat;
        this.initialized = false;
        this.dependencies = audit.dependencies;
    }

    templateModel()
    {
        return {
            subjectName: this.subject['data']['name']
        }
    }

    beforeRender()
    {
        if (this.$values)
            this.$values.empty();
    }

    afterRender()
    {
        this.$changeLabel = this.find('.changeLabel');
        this.$values =this.find('.values');
        const timestamp = new DateFormat(window.SystemSettings.dateFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(this.timestamp));
        this.find('.timestamp').text(timestamp);
    }

    formatDate(date)
    {
        return Date.parseJSONDate(date).format(this.dateFormat);
    }

    findEntityInDependencies(type, id)
    {
        return this.dependencies.find(entity => entity.type === type && entity.id === id)['data'];
    }
}

export class RenamedAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat, tooltip)
    {
        super(audit, dateFormat);
        this.tooltip = tooltip;
    }

    afterRender()
    {
        super.afterRender();
        const $nameLabel = $("<span class='dashedLink'>" + messageResource.getMessage('audit.audit_history.name') + " </span>");
        this.$changeLabel.html(messageResource.getMessage('audit.audit_history.change_record', ['']));
        this.$changeLabel.append($nameLabel);
        this.tooltip.subscribeToMouseEvents($nameLabel, () => this.tooltip.setView(new ChangedValuesRow(this.data['oldName'], this.data['newName'])));
    }
}

export class DeadlineAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat)
    {
        super(audit, dateFormat);
    }

    afterRender()
    {
        super.afterRender();
        this.$changeLabel.html(messageResource.getMessage('audit.audit_history.change_record', [messageResource.getMessage('audit.audit_history.deadline')]));
        const notDefinedLabel = messageResource.getMessage('audit.audit_history.deadline_not_defined');
        const oldValue = this.data['oldDeadline'] ? this.formatDate(this.data['oldDeadline']) : notDefinedLabel;
        const newValue = this.data['newDeadline'] ? this.formatDate(this.data['newDeadline']) : notDefinedLabel;
        new ChangedValuesRow(oldValue, newValue).init(this.$values);
    }
}

export class EstimateAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat)
    {
        super(audit, dateFormat);
    }

    afterRender()
    {
        super.afterRender();
        const notDefinedLabel = messageResource.getMessage('audit.audit_history.estimate_not_defined');
        this.$changeLabel.html(messageResource.getMessage('audit.audit_history.change_record', [messageResource.getMessage('audit.audit_history.estimate')]));
        const oldValue = this.data['oldEstimateTime'] ? UserTime.formatTimeWithDigitSeparator(parseInt(this.data['oldEstimateTime'])) : notDefinedLabel;
        const newValue = this.data['newEstimateTime'] ? UserTime.formatTimeWithDigitSeparator(parseInt(this.data['newEstimateTime'])) : notDefinedLabel;
        new ChangedValuesRow(oldValue, newValue).init(this.$values);
    }
}

export class StatusAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat)
    {
        super(audit, dateFormat);
    }

    afterRender()
    {
        super.afterRender();
        this.$changeLabel.html(messageResource.getMessage('audit.audit_history.change_record', [messageResource.getMessage('audit.audit_history.status')]));
        const openTaskLabel = messageResource.getMessage('task.status.open');
        const completeTaskLabel = messageResource.getMessage('task.status.completed');
        const oldValue = (this.type === AuditActionTypes.COMPLETED) ? openTaskLabel : completeTaskLabel;
        const newValue = (this.type === AuditActionTypes.COMPLETED) ? completeTaskLabel : openTaskLabel;
        new ChangedValuesRow(oldValue, newValue).init(this.$values);
    }
}

export class WorkflowStatusAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat)
    {
        super(audit, dateFormat);
    }

    afterRender()
    {
        super.afterRender();

        this.$changeLabel.html(messageResource.getMessage('audit.audit_history.change_record', [messageResource.getMessage('audit.audit_history.status')]));
        const oldWorkflowStatusId = parseInt(this.data['oldWorkflowStatusId']);
        const newWorkflowStatusId = parseInt(this.data['newWorkflowStatusId']);
        const oldValue = this.formatWorkflowStatusName(oldWorkflowStatusId);
        const newValue = this.formatWorkflowStatusName(newWorkflowStatusId);
        new ChangedValuesRow(oldValue, newValue).init(this.$values);
    }

    formatWorkflowStatusName(workflowStatusId)
    {
        const workflowStatusesEnabled = isEnabled(Feature.TWS);

        const workflowStatusBean = this.findEntityInDependencies(AuditEntityTypes['WORKFLOW_STATUS'], workflowStatusId);
        const typeName = workflowStatusBean.type === WorkflowStatusType.COMPLETED ? messageResource.getMessage('task.status.completed') :
                         messageResource.getMessage('task.status.open');
        return workflowStatusesEnabled ? typeName + ": " + workflowStatusBean['name'] : typeName;
    }
}

export class TypeOfWorkAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat, tooltip)
    {
        super(audit, dateFormat);
        this.tooltip = tooltip;
    }

    afterRender()
    {
        super.afterRender();
        const $typeOfWork = $("<span class='dashedLink'>" + messageResource.getMessage('audit.audit_history.type_of_work') + " </span>");
        this.$changeLabel.html(messageResource.getMessage('audit.audit_history.change_record', ['']));
        this.$changeLabel.append($typeOfWork);
        const oldValue = this.findEntityInDependencies(AuditEntityTypes['TYPE_OF_WORK'], parseInt(this.data['oldBillingTypeId']))['name'];
        const newValue = this.findEntityInDependencies(AuditEntityTypes['TYPE_OF_WORK'], parseInt(this.data['newBillingTypeId']))['name'];
        this.tooltip.subscribeToMouseEvents($typeOfWork, () => this.tooltip.setView(new ChangedValuesRow(oldValue, newValue)));
    }
}

export class DescriptionAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat)
    {
        super(audit, dateFormat);
    }

    afterRender()
    {
        super.afterRender();
        this.$changeLabel.html(messageResource.getMessage('audit.audit_history.change_record', [messageResource.getMessage('audit.audit_history.description')]));
    }
}

export class MoveTaskToAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat, tooltip)
    {
        super(audit, dateFormat);
        this.tooltip = tooltip;
    }

    afterRender()
    {
        super.afterRender();
        const $anotherProject = $("<span class='dashedLink'>" + messageResource.getEscapedMessage('audit.audit_history.another_project') + " </span>");
        this.$changeLabel.html(messageResource.getEscapedMessage('audit.audit_history.move_task') + ' ');
        this.$changeLabel.append($anotherProject)
        const $tooltipDiv = $("<div class='moveTaskTooltipDiv'/>");
        if (this.data['oldCustomerId'] !== this.data['newCustomerId'])
        {
            const oldValue = this.findEntityInDependencies(AuditEntityTypes['CUSTOMER'], parseInt(this.data['oldCustomerId']))['name'];
            const newValue = this.findEntityInDependencies(AuditEntityTypes['CUSTOMER'], parseInt(this.data['newCustomerId']))['name'];
            new ChangedValuesRow(oldValue, newValue).init($tooltipDiv);
        }
        const oldValue = this.findEntityInDependencies(AuditEntityTypes['PROJECT'], parseInt(this.data['oldProjectId']))['name'];
        const newValue = this.findEntityInDependencies(AuditEntityTypes['PROJECT'], parseInt(this.data['newProjectId']))['name'];
        new ChangedValuesRow(oldValue, newValue).init($tooltipDiv);
        this.tooltip.subscribeToMouseEvents($anotherProject, () => {
            this.tooltip.setView(null);
            this.tooltip.$el.append($tooltipDiv);
        })
    }
}

export class MoveProjectToAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat, tooltip)
    {
        super(audit, dateFormat);
        this.tooltip = tooltip;
    }

    afterRender()
    {
        super.afterRender();
        const $anotherCustomer = $("<span class='dashedLink'>" + messageResource.getEscapedMessage('audit.audit_history.another_customer') + " </span>");
        this.$changeLabel.html(messageResource.getEscapedMessage('audit.audit_history.move_project') + ' ');
        this.$changeLabel.append($anotherCustomer)
        const oldValue = this.findEntityInDependencies(AuditEntityTypes['CUSTOMER'], parseInt(this.data['oldCustomerId']))['name'];
        const newValue = this.findEntityInDependencies(AuditEntityTypes['CUSTOMER'], parseInt(this.data['newCustomerId']))['name'];
        this.tooltip.subscribeToMouseEvents($anotherCustomer, () => {
            this.tooltip.setView(    new ChangedValuesRow(oldValue, newValue) );
        })
    }
}

export class ArchiveStatusAuditRecord extends UpdateAuditRecord
{
    constructor(audit, dateFormat)
    {
        super(audit, dateFormat);
    }

    afterRender()
    {
        super.afterRender();
        this.$changeLabel.html(messageResource.getMessage('audit.audit_history.change_record', [messageResource.getMessage('audit.audit_history.status')]));
        const activeCPLabel = messageResource.getMessage('customer.edit.status.active');
        const archiveCPLabel = messageResource.getMessage('customer.edit.status.archived');
        const oldValue = (this.type === AuditActionTypes.ARCHIVED) ? activeCPLabel : archiveCPLabel;
        const newValue = (this.type === AuditActionTypes.ARCHIVED) ? archiveCPLabel : activeCPLabel;
        new ChangedValuesRow(oldValue, newValue).init(this.$values);
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/auditHsitory/UpdateAuditRecord.js